<capra-banner
  warningMessage="{{ warningText }}"
  tipMessage="{{ tipMessage }}"
  class="banner-container"
  icon="illo-icon-lock"
>
  <mode-calendly-popup-button capra-banner-actions>
    <capra-button text="Upgrade"></capra-button>
  </mode-calendly-popup-button>
</capra-banner>
